export default class ChatMessage {
    constructor(data) {
        if (data) {
            this.id = data.id;
            this.created = Date.parse(data.created);
            this.update = data.update ? Date.parse(data.update) : null;
            this.deleted = data.deleted;
            this.text = data.text;
            this.authorUuid = data.authorUuid;
            this.authorName = data.authorName;
            this.authorStatus = data.authorStatus;
            this.translations = data.translations;

            Object.seal(this);
        }
    }
}
